import { render, staticRenderFns } from "./idp-choose.vue?vue&type=template&id=3e528d68&"
import script from "./idp-choose.ts?vue&type=script&lang=ts&"
export * from "./idp-choose.ts?vue&type=script&lang=ts&"
import style0 from "./idp-choose.vue?vue&type=style&index=0&id=3e528d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports